@if (notFound()) {
  <span class="body-large order-detail-message">{{ 'orders.ui.ordineNonDisponibile' | transloco }}</span>
}

@if (detail(); as detail) {
  @let totals = summary()!;

  <div class="order-detail-actions">
    <button *uiCan="capabilityNames.ordineCrea" matButton="outlined" type="button" [disabled]="busy()" (click)="duplicate()">
      {{ 'orders.ui.duplicaOrdine' | transloco }}
    </button>

    <button
      mat-icon-button
      type="button"
      class="order-alerts-button"
      [attr.aria-label]="'orders.ui.notificheDelCliente' | transloco"
      [matBadge]="alerts().length"
      [matBadgeHidden]="alerts().length === 0"
      [disabled]="alerts().length === 0"
      (click)="openAlerts()">
      <i class="fa-solid fa-bell"></i>
    </button>
  </div>

  @if (detail.numeroTaskDaRisolvere > 0) {
    <div class="order-banner order-banner--warning order-detail-wide">
      <i class="fa-solid fa-triangle-exclamation order-banner-icon"></i>
      <span class="body-medium emphasized">{{ 'orders.ui.sonoPresentiTaskDaRisolvere' | transloco: { value0: (detail.numeroTaskDaRisolvere) } }}</span>
    </div>
  }

  <div class="order-summary-card">
    <div class="order-summary-title">
      <span class="title-large-emphasized">{{ totals.ragioneSociale }}</span>
      @if (detail.cliente) {
        <cus-icon-alert [alert]="{ stato: detail.cliente.statoAffidamento, valore: null, toolTip: null }" />
      }
    </div>

    <dl class="order-summary-grid">
      <dt class="label-medium">{{ 'orders.ui.importoCarrello' | transloco }}</dt>
      <dd class="body-large">{{ totals.importo | translocoCurrency: 'symbol' : { useGrouping: true } }}</dd>

      @if (totals.provvigione != null) {
        <dt class="label-medium">{{ 'orders.ui.provvigioneAgente' | transloco }}</dt>
        <dd class="body-large">{{ totals.provvigione | translocoCurrency: 'symbol' : { useGrouping: true } }}</dd>
      }

      <dt class="label-medium">VAT</dt>
      <dd class="body-large">{{ totals.partitaIva }}</dd>
    </dl>
  </div>

  <!-- Sotto-ordini: le commesse create da ERP, con il triangolo se c'è un task da decidere -->
  @if (detail.commesse.length > 0) {
    <mat-chip-listbox class="sub-orders" [attr.aria-label]="'orders.ui.sottoOrdini' | transloco" [hideSingleSelectionIndicator]="true">
      @for (item of views(); track item.id) {
        <mat-chip-option [selected]="item.id === view()?.id" (selectionChange)="onSubOrderChange($event, item.id)">
          @if (item.tasks.length > 0) {
            <i class="fa-regular fa-triangle-exclamation sub-order-warning"></i>
          }
          {{ item.label }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  }

  @if (view(); as current) {
    <!-- In testa a ogni scheda: il tag e i task da decidere, che portano al task -->
    <ng-template #statusTemplate>
      <ord-order-status-badge [tag]="current.tag" />

      @for (task of current.tasks; track task.id) {
        <div class="order-banner order-banner--warning">
          <i class="fa-solid fa-triangle-exclamation order-banner-icon"></i>
          <div class="order-banner-text">
            <span class="body-medium">{{ task.nome || task.descrizione }}</span>
            <button type="button" class="order-banner-link body-medium" (click)="openTask(task)">{{ 'orders.ui.vaiAlDettaglio' | transloco }}</button>
          </div>
        </div>
      }
    </ng-template>

    <ng-template #changeValueTemplate let-value let-change="change">
      @if (value == null) {
        -
      } @else {
        @switch (change.campo) {
          @case ('Quantita') {
            {{ 'orders.ui.pz' | transloco: { value0: (value | translocoDecimal: { useGrouping: true, maximumFractionDigits: 0 }) } }}
          }
          @case ('Prezzo') {
            {{ value | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 4, maximumFractionDigits: 4 } }}@if (change.unitaMisura) {/{{ change.unitaMisura }}}
          }
          @case ('PercProvvigione') {
            {{ (value / 100) | translocoPercent: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
          }
          @default {
            {{ (value / 100) | translocoPercent: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }}
          }
        }
      }
    </ng-template>

    <mat-tab-group
      animationDuration="0ms"
      class="tabs"
      mat-align-tabs="start"
      mat-stretch-tabs="false"
      [selectedIndex]="selectedTab()"
      (selectedIndexChange)="selectedTab.set($event)">
      <mat-tab [label]="'orders.ui.informazioni' | transloco">
        <div class="tab-content">
          <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>

          <div class="detail-panels">
            @if (current.shipping; as shipping) {
              <div class="detail-card">
                <span class="title-small emphasized">{{ 'orders.ui.dettaglioSpedizione' | transloco }}</span>
                <span class="body-medium">{{ shipping.trasportatore ?? '-' }}</span>
                @if (shipping.data) {
                  <span class="body-medium">
                    {{ shipping.consegnato ? ('orders.ui.consegnatoIl' | transloco) : ('orders.ui.speditoIl' | transloco) }} {{ shipping.data | date: 'dd/MM/yyyy' }}
                  </span>
                }
              </div>
            }

            @if (current.anomalies.length > 0) {
              <mat-expansion-panel class="detail-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title class="title-small emphasized">{{ 'orders.ui.anomalie' | transloco: { value0: (current.anomalies.length) } }}</mat-panel-title>
                </mat-expansion-panel-header>

                <ul class="order-anomalies">
                  @for (anomaly of current.anomalies; track $index) {
                    <li class="order-anomaly body-medium">
                      <i class="fa-regular fa-triangle-exclamation order-anomaly-icon"></i>
                      {{ anomaly }}
                    </li>
                  }
                </ul>
              </mat-expansion-panel>
            }

            <mat-expansion-panel class="detail-panel">
              <mat-expansion-panel-header>
                <mat-panel-title class="title-small emphasized">{{ 'orders.ui.anagraficaProposta' | transloco }}</mat-panel-title>
              </mat-expansion-panel-header>

              <dl class="order-summary-grid">
                <dt class="label-medium">{{ 'orders.ui.numeroOrdine' | transloco }}</dt>
                <dd class="body-large">#{{ current.numeroOrdine }}</dd>

                <dt class="label-medium">{{ 'orders.ui.dataInserimento' | transloco }}</dt>
                <dd class="body-large">{{ current.dataInserimento ? (current.dataInserimento | date: 'dd/MM/yyyy') : '-' }}</dd>

                @if (current.provvigione != null) {
                  <dt class="label-medium">{{ 'orders.ui.provvigione' | transloco }}</dt>
                  <dd class="body-large">{{ current.provvigione | translocoCurrency: 'symbol' : { useGrouping: true } }}</dd>
                }

                @if (current.deposito != null) {
                  <dt class="label-medium">{{ 'orders.ui.codiceDeposito' | transloco }}</dt>
                  <dd class="body-large">{{ current.deposito }}</dd>
                }

                @if (detail.idCarrello) {
                  <dt class="label-medium">{{ 'orders.ui.numeroCarrello' | transloco }}</dt>
                  <dd class="body-large">{{ detail.idCarrello }}</dd>
                }
              </dl>
            </mat-expansion-panel>

            <mat-expansion-panel class="detail-panel">
              <mat-expansion-panel-header>
                <mat-panel-title class="title-small emphasized">{{ 'orders.ui.prodotti' | transloco }}</mat-panel-title>
              </mat-expansion-panel-header>

              <ul class="order-products">
                @for (product of current.products; track product.id) {
                  <li class="order-product">
                    <div class="order-product-info">
                      <span class="body-large emphasized">{{ product.nome }}</span>
                      <span class="body-medium">
                        @if (product.sku) { {{ product.sku }} - }{{ 'orders.ui.quantita' | transloco: { value0: (product.imballo), value1: (product.unitaFatturabile), value2: (product.unitaMisura), value3: (product.quantita) } }}
                      </span>
                    </div>
                    <span class="body-large emphasized">{{ product.importo | translocoCurrency: 'symbol' : { useGrouping: true } }}</span>
                  </li>
                }
              </ul>
            </mat-expansion-panel>

            @if (detail.ordine) {
              <mat-expansion-panel class="detail-panel">
                <mat-expansion-panel-header>
                  <mat-panel-title class="title-small emphasized">
                    {{ 'orders.ui.attivita' | transloco: { value0: (history().length), value1: (history().length === 1 ? ('orders.ui.evento' | transloco) : ('orders.ui.eventi' | transloco)) } }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="activity-history-card-content">
                  @for (step of history(); track $index; let isLast = $last) {
                    @let future = !step.outcome && !step.current;
                    @let rejected = step.outcome === 'Rejected';
                    <div
                      class="activity-history-entry"
                      [class.activity-history-entry-done]="!!step.outcome && !rejected"
                      [class.activity-history-entry-rejected]="rejected"
                      [class.activity-history-entry-current]="step.current"
                      [class.activity-history-entry-future]="future"
                      [class.activity-history-entry-last]="isLast">
                      <div class="activity-history-step">
                        <span class="activity-history-marker" [class.activity-history-marker-current]="step.current" aria-hidden="true">
                          <i
                            class="activity-history-marker-icon"
                            [class.fa-regular]="future"
                            [class.fa-solid]="!future"
                            [class.fa-circle-check]="!!step.outcome && !rejected"
                            [class.fa-circle-xmark]="rejected"
                            [class.fa-circle]="!step.outcome"></i>
                        </span>
                        <div class="activity-history-role-content">
                          @if (future) {
                            <span class="activity-history-role-date body-medium">{{ 'orders.ui.prossimoApprovatore' | transloco }}</span>
                          } @else if (step.date) {
                            <span class="activity-history-role-date body-medium" [class.activity-history-date-current]="step.current">
                              {{ step.date | date: 'dd/MM/yyyy' }} · {{ step.date | date: 'HH:mm' }}
                              @if (step.current) {
                                {{ 'orders.ui.attivitaInCarico' | transloco }}
                              }
                            </span>
                          }
                          @if (step.user) {
                            <span class="activity-history-user body-medium" [class.activity-history-user-future]="future">
                              {{ step.user }}@if (step.group) { - <span class="body-medium-emphasized">{{ step.group }}</span>}
                            </span>
                          }
                          @if (step.outcome) {
                            <span class="activity-history-role-notes body-medium">
                              {{ step.text }}@if (step.role) { [{{ step.role }}]}
                            </span>
                          }
                          @for (change of step.changes; track $index) {
                            <span class="activity-history-role-notes body-medium-emphasized">
                              {{ change.nomeProdotto || '-' }} · {{ changeFieldLabels[change.campo] }}:
                              <ng-container *ngTemplateOutlet="changeValueTemplate; context: { $implicit: change.prima, change: change }"></ng-container>
                              →
                              <ng-container *ngTemplateOutlet="changeValueTemplate; context: { $implicit: change.dopo, change: change }"></ng-container>
                            </span>
                          }
                          @if (step.note) {
                            <span class="activity-history-role-notes body-medium">{{ step.note }}</span>
                          }
                        </div>
                      </div>

                      @if (step.attachments.length) {
                        <div class="activity-history-attachments">
                          @for (attachment of step.attachments; track attachment.id) {
                            <div class="activity-attachment-card">
                              <i class="fa-regular fa-file-lines activity-attachment-file-icon" aria-hidden="true"></i>
                              <span class="activity-attachment-name body-medium-emphasized">{{ fileName(attachment.filePath) }}</span>
                              <button
                                type="button"
                                class="activity-attachment-download"
                                [attr.aria-label]="'orders.ui.scaricaAllegato' | transloco"
                                (click)="downloadAttachment(attachment, step.taskId)">
                                <i class="fa-regular fa-download" aria-hidden="true"></i>
                              </button>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'orders.ui.documenti' | transloco">
        <div class="tab-content">
          <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>

          <div class="order-documents">
            @if (quoteAvailable()) {
              <div *uiCan="capabilityNames.preventivoGenera" class="document-card">
                <i class="fa-regular fa-file-pdf document-icon" aria-hidden="true"></i>
                <span class="body-large emphasized document-name">{{ 'orders.ui.preventivoOriginale' | transloco }}</span>
                <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.scaricaIlPreventivo' | transloco" (click)="downloadQuote()">
                  <i class="fa-regular fa-download"></i>
                </button>
              </div>
            }

            <div class="document-card document-card--disabled">
              <div class="document-name">
                <span class="body-large">{{ 'orders.ui.confermaDOrdine' | transloco }}</span>
                <span class="body-medium">{{ 'orders.ui.disponibileDopoAutorizzazione' | transloco }}</span>
              </div>
              <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.scaricaLaConfermaDOrdine' | transloco" disabled>
                <i class="fa-regular fa-download"></i>
              </button>
            </div>

            <div class="order-banner order-banner--info">
              <i class="fa-solid fa-circle-info order-banner-icon"></i>
              <span class="body-medium">{{ 'orders.ui.laConfermaDOrdineSaraDisponibileSoloDopoLAutorizzazioneDellOrdine' | transloco }}</span>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'orders.ui.note' | transloco">
        <div class="tab-content">
          <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>

          <div class="order-notes">
            @for (note of current.notes; track $index) {
              <div class="note-card">
                <span class="body-medium emphasized">{{ note.title }}</span>
                <span class="body-medium">{{ note.text }}</span>
              </div>
            } @empty {
              <span class="body-medium">{{ 'orders.ui.nessunaNota' | transloco }}</span>
            }
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
}
